import React from 'react'
import { Button } from 'react-bootstrap'
import AwsConfig from '../../Config/AwsConfig'

export default function ListsDisplayUi(props) {
  const {
    selectedListCrud,
    sendSelectedList,
    valueChanged,
    setvalueChanged,
    //  setMovieListTrueValue,
  } = props

  const poster = url => {
    if (url) {
      const cdnurl = AwsConfig.movieCdnUrl
      if (url && !url.includes(cdnurl)) {
        url = cdnurl + url
        return url
      }

      return url
    }
  }

  const handleMoveItem = (direction, index) => {
    // setMovieListTrueValue(true)
    const selectedListTemp = [...selectedListCrud]
    if (direction === 'up') {
      selectedListTemp[index] = selectedListTemp.splice(index - 1, 1, selectedListTemp[index])[0]
    } else {
      selectedListTemp[index] = selectedListTemp.splice(index + 1, 1, selectedListTemp[index])[0]
    }

    const valueChangedTemp = { ...valueChanged }
    valueChangedTemp.selectedList = true
    setvalueChanged(valueChangedTemp)
    sendSelectedList(selectedListTemp)
  }

  const handleDelete = index => {
    // setMovieListTrueValue(true)
    const selectedListTemp = [...selectedListCrud]
    selectedListTemp.splice(index, 1)
    sendSelectedList(selectedListTemp)
    const valueChangedTemp = { ...valueChanged }
    valueChangedTemp.selectedList = true
    setvalueChanged(valueChangedTemp)
  }

  return (
    <>
      {selectedListCrud.map(
        (item, index) =>
          item && (
            <div key={index} className='d-flex m-3' style={{ gap: '10px' }}>
              <div className='d-flex justify-content-between' style={{ gap: '10px' }}>
                <div
                  className='moviePoster mr-1'
                  style={{ height: '12rem', width: '12rem', objectFit: 'cover' }}
                >
                  <img
                    src={poster(
                      item && item.movieListImage
                        ? item.movieListImage
                        : item && item.dynamicListImage
                        ? item.dynamicListImage
                        : '',
                    )}
                    alt={item.title_En}
                    style={{ height: '100%', width: '100%' }}
                  />
                </div>
                <div>
                  <label>title_En</label>
                  <input
                    type='text'
                    value={item.title_En} /* onChange={event => sendSelectedList(item)} */
                    className='rounded'
                    disabled
                  />
                  <label>description_En</label>
                  <textarea
                    type='text'
                    value={item.description_En}
                    className='rounded'
                    rows={4}
                    cols={30}
                    disabled
                  />
                </div>
                <div>
                  <label>title_Te</label>
                  <input
                    type='text'
                    value={item.title_En} /* onChange={event => sendSelectedList(item)} */
                    className='rounded'
                    disabled
                  />
                  <label>description_Te</label>
                  <textarea
                    type='text'
                    value={item.description_Te}
                    className='rounded'
                    rows={4}
                    cols={30}
                    disabled
                  />
                </div>
              </div>
              <div
                className='d-flex justify-content-center align-items-center'
                style={{ width: '10%' }}
              >
                <Button
                  variant='danger'
                  className='btn-sm mr-1 ml-1'
                  onClick={() => handleDelete(index)}
                >
                  <i className='fa fa-times' />
                </Button>
                {index !== 0 && (
                  <Button
                    variant='primary'
                    className='btn-sm mr-1 ml-1'
                    onClick={() => handleMoveItem('up', index)}
                  >
                    <i className='fa  fa-angle-double-up' />
                  </Button>
                )}
                {index !== selectedListCrud.length - 1 && (
                  <Button
                    variant='primary'
                    className='btn-sm mr-1 ml-1'
                    onClick={() => handleMoveItem('down', index)}
                  >
                    <i className='fa  fa-angle-double-down	' />
                  </Button>
                )}
              </div>
            </div>
          ),
      )}
    </>
  )
}
